import {
  GoogleLoginProvider,
  SocialAuthServiceConfig,
  SocialLoginModule,
  SOCIAL_AUTH_CONFIG,
} from "@abacritt/angularx-social-login";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import {
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
} from "@angular/core";
import { provideClientHydration } from "@angular/platform-browser";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
} from "@angular/router";
import { provideTranslateService } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { definePreset } from "@primeng/themes";
import LaraLightBlue from "@primeng/themes/lara";
import { RECAPTCHA_V3_SITE_KEY } from "ng-recaptcha-2";
import { provideEnvironmentNgxMask } from "ngx-mask";
import { providePrimeNG } from "primeng/config";
import ptBrLocale from "primelocale/pt-BR.json";
import { environment } from "../environments/environment";
import { routes } from "./app.routes";
import { authInterceptor } from "./interceptors/auth.interceptor";

const MyLaraLightBlue = definePreset(LaraLightBlue, {
  semantic: {
    primary: {
      50: "{blue.50}",
      100: "{blue.100}",
      200: "{blue.200}",
      300: "{blue.300}",
      400: "{blue.400}",
      500: "{blue.500}",
      600: "{blue.600}",
      700: "{blue.700}",
      800: "{blue.800}",
      900: "{blue.900}",
      950: "{blue.950}",
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.RECAPTCHA_SITE_KEY_V3,
    },
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: "enabled",
        anchorScrolling: "enabled",
      }),
    ),
    provideAnimationsAsync(),
    provideAnimations(),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideClientHydration(),
    provideEnvironmentNgxMask(),
    providePrimeNG({
      theme: {
        preset: MyLaraLightBlue,
      },
      translation: ptBrLocale["pt-BR"],
    }),
    { provide: LOCALE_ID, useValue: "pt-BR" },
    provideTranslateService({
      lang: "pt",
      fallbackLang: "pt",
      loader: provideTranslateHttpLoader({
        prefix: "/assets/translations/",
        suffix: ".json",
      }),
    }),

    importProvidersFrom(SocialLoginModule),
    {
      provide: SOCIAL_AUTH_CONFIG,
      useValue: {
        autoLogin: false,
        lang: "pt_BR",
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(environment.GOOGLE_CLIENT_ID, {
              oneTapEnabled: false,
            }),
          },
        ],
        onError: (err: unknown) => {
          console.error("Social auth error", err);
        },
      } as SocialAuthServiceConfig,
    },
  ],
};
